import smartDate from "@qrohlf/smart-date";
import { SectionBox } from "common/styleguide/SectionBox";
import fetchJSON from "lib/fetchJSON";
import React from "react";
import { AdminLayout, Grid } from "../layoutComponents";
import styles from "./AdminDashboard.scss";

export class AdminDashboard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dashData: {},
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    fetchJSON("/admin/dashboard.json")
      .then((dashData) => this.setState({ dashData, loading: false }))
      .catch((e) => console.error(JSON.stringify(e, null, "  ")));
  };

  render() {
    const { loading, dashData } = this.state;

    if (loading) {
      return <AdminLayout readonly loading title="RWGPS Dashboard" />;
    }

    return (
      <AdminLayout readonly title="RWGPS Dashboard">
        <Grid cols={2}>
          <GridItem
            title="Prod iOS Version"
            value={dashData.app_versions_ios.prod.version}
            context={`Published ${smartDate(dashData.app_versions_ios.prod.release_date)}`}
          />
          <GridItem
            title="Latest iOS Version"
            value={dashData.app_versions_ios.latest.version}
            context={`Published ${smartDate(dashData.app_versions_ios.latest.release_date)}`}
          />
          {/* <GridItem
            title='iOS QA Status'
            value='❌ 1.8.3.208'
            context='98% passing – 5 failures, 44 not tested' /> */}
          <GridItem
            title="Prod Android Version"
            value={dashData.app_versions_android.prod.version}
            context={`Published ${smartDate(dashData.app_versions_android.prod.release_date)}`}
          />
          <GridItem
            title="Latest Android Version"
            value={dashData.app_versions_android.latest.version}
            context={`Published ${smartDate(dashData.app_versions_android.latest.release_date)}`}
          />
          {/* <GridItem
            title='Android QA Status'
            value='✅ 1.8.5.8'
            context='100% passing - 2 known issues, 39 not tested' /> */}
        </Grid>
      </AdminLayout>
    );
  }
}

const GridItem = ({ title, value, context }) => (
  <SectionBox title={title}>
    <div className={styles.GridItem}>
      <div className={styles.value}>{value}</div>
      <div className={styles.context}>{context}</div>
    </div>
  </SectionBox>
);
